import { Action } from '@ngrx/store';
import { HttpErrorResponse } from '@angular/common/http';
import { OpusJobsCriteria, OpusJob } from '../../models';

export enum OpusJobsActionTypes {
  LoadOpusJobs = '[OpuJobs] Load Opus Jobs',
  LoadOpusJobsSuccess = '[OpuJobs] Load Opus Jobs Success',
  LoadOpusJobsFailure = '[OpuJobs] Load Opus Jobs Failure',
  UpdateOpusJobs = '[OpuJobs] Update Opus Jobs',
  UpdateOpusJobsSuccess = '[OpuJobs] Update Opus Jobs Success',
  UpdateOpusJobsFailure = '[OpuJobs] Update Opus Jobs Failure'
}

export class LoadOpusJobs implements Action {
  readonly type = OpusJobsActionTypes.LoadOpusJobs;
  constructor(public payload: OpusJobsCriteria) {}
}

export class LoadOpusJobsSuccess implements Action {
  readonly type = OpusJobsActionTypes.LoadOpusJobsSuccess;
  constructor(public payload: OpusJob[]) {}
}

export class LoadOpusJobsFailure implements Action {
  readonly type = OpusJobsActionTypes.LoadOpusJobsFailure;
  constructor(public payload: any) {}
}
export class UpdateOpusJobs implements Action {
  readonly type = OpusJobsActionTypes.UpdateOpusJobs;
  constructor(public payload: { changed: OpusJob[] }) {}
}

export class UpdateOpusJobsSuccess implements Action {
  readonly type = OpusJobsActionTypes.UpdateOpusJobsSuccess;
  constructor(public payload: { changed: OpusJob[] }) {}
}

export class UpdateOpusJobsFailure implements Action {
  readonly type = OpusJobsActionTypes.UpdateOpusJobsFailure;
  constructor(public payload: any) {}
}

export type OpubJobsActions = LoadOpusJobs | LoadOpusJobsFailure | LoadOpusJobsSuccess | UpdateOpusJobs | UpdateOpusJobsSuccess | UpdateOpusJobsFailure;
